var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"90px"}},[_c('Nav'),_c('Fix'),_c('div',{staticClass:"container"},[_c('el-card',{staticClass:"top"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.pageContent)}})])],1),_c('Footer',{staticClass:"top"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }